import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "size": "small",
      "title": "筛选"
    }
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    staticClass: "fold"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "公文名称",
      "prop": "fileName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公文名称"
    },
    model: {
      value: _vm.form.fileName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileName", $$v);
      },
      expression: "form.fileName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "拟稿日期",
      "prop": "createTime"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.createTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "createTime", $$v);
      },
      expression: "form.createTime"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)])], 1), _c('a-card', {
    attrs: {
      "size": "small",
      "title": "列表",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "dataSource": _vm.tableData,
      "columns": _vm.columns,
      "pagination": _vm.paginationTable,
      "bordered": "",
      "rowKey": "rowNumber",
      "scroll": {
        y: 550
      }
    },
    scopedSlots: _vm._u([{
      key: "docType",
      fn: function fn(text, record) {
        return [record.docType === 1 ? _c('span', [_vm._v("发文")]) : _vm._e(), record.docType === 2 ? _c('span', [_vm._v("收文")]) : _vm._e()];
      }
    }, {
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis",
          attrs: {
            "title": "".concat(row.draftUser, "(").concat(row.organName, "/").concat(row.postName, ")")
          }
        }, [_vm._v(" " + _vm._s(row.draftUser) + " (" + _vm._s(row.organName) + " / " + _vm._s(row.postName) + ") ")])];
      }
    }, {
      key: "auditStatus",
      fn: function fn(text, record) {
        return [record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('span', {
          staticClass: "ant-tag ant-tag-has-color",
          staticStyle: {
            "text-align": "justify",
            "text-align-last": "justify",
            "width": "52px",
            "background-color": "rgb(24, 144, 255)"
          }
        }, [_vm._v(" 待审核 ")]) : _vm._e(), record.auditStatus === 0 ? _c('span', {
          staticClass: "ant-tag ant-tag-has-color",
          staticStyle: {
            "text-align": "justify",
            "text-align-last": "justify",
            "width": "52px",
            "background-color": "rgb(220, 33, 39)"
          }
        }, [_vm._v(" 不通过 ")]) : _vm._e(), record.auditStatus === 1 ? _c('span', {
          staticClass: "ant-tag ant-tag-has-color",
          staticStyle: {
            "text-align": "justify",
            "text-align-last": "justify",
            "width": "52px",
            "background-color": "rgb(79, 191, 73)"
          }
        }, [_vm._v(" 通过 ")]) : _vm._e()];
      }
    }, {
      key: "nowStep",
      fn: function fn(text, record) {
        return [record.tempId === 1 && record.auditStep === 1 ? _c('span', [_vm._v("初核")]) : _vm._e(), record.tempId === 1 && record.auditStep === 2 ? _c('span', [_vm._v("签发")]) : _vm._e(), record.tempId === 2 && record.auditStep === 1 ? _c('span', [_vm._v("初核")]) : _vm._e(), record.tempId === 2 && record.auditStep === 2 ? _c('span', [_vm._v("复核")]) : _vm._e(), record.tempId === 2 && record.auditStep === 3 ? _c('span', [_vm._v("会签")]) : _vm._e(), record.tempId === 2 && record.auditStep === 4 ? _c('span', [_vm._v("签发")]) : _vm._e(), record.tempId === 2 && record.auditStep === 5 ? _c('span', [_vm._v("校对")]) : _vm._e(), record.tempId === 2 && record.auditStep === 6 ? _c('span', [_vm._v("打印")]) : _vm._e(), record.tempId === 3 && record.auditStep === 1 ? _c('span', [_vm._v("拟稿部门审核")]) : _vm._e(), record.tempId === 3 && record.auditStep === 2 ? _c('span', [_vm._v("审稿部门审核")]) : _vm._e(), record.tempId === 3 && record.auditStep === 3 ? _c('span', [_vm._v(" 分管校级领导审核 ")]) : _vm._e(), record.tempId === 3 && record.auditStep === 4 ? _c('span', [_vm._v("理事长签发")]) : _vm._e(), record.tempId === 4 && record.auditStep === 1 ? _c('span', [_vm._v(" 行政办负责人审核 ")]) : _vm._e(), record.tempId === 4 && record.auditStep === 2 ? _c('span', [_vm._v("党委书记审核")]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewClick(record);
            }
          }
        }, [_vm._v("查看")]), (record.tempId === 1 || record.tempId === 2) && record.auditStep === 1 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.firstTrial(record);
            }
          }
        }, [_vm._v(" 初核 ")]) : _vm._e(), record.tempId === 2 && record.auditStep === 2 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.reCheck(record);
            }
          }
        }, [_vm._v(" 复核 ")]) : _vm._e(), record.tempId === 2 && record.auditStep === 3 && record.result === -1 && record.auditStatus != 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.groupSign(record);
            }
          }
        }, [_vm._v(" 会签 ")]) : _vm._e(), record.tempId === 1 && record.auditStep === 2 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.signIssue(record);
            }
          }
        }, [_vm._v(" 签发 ")]) : _vm._e(), record.tempId === 2 && record.auditStep === 4 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.signIssue(record);
            }
          }
        }, [_vm._v(" 签发 ")]) : _vm._e(), record.tempId === 2 && record.auditStep === 5 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.proofread(record);
            }
          }
        }, [_vm._v(" 校对 ")]) : _vm._e(), record.tempId === 2 && record.auditStep === 6 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.printClick(record);
            }
          }
        }, [_vm._v(" 打印 ")]) : _vm._e(), record.tempId === 3 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.reView(record);
            }
          }
        }, [_vm._v(" 审核 ")]) : _vm._e(), record.tempId === 4 && record.auditStatus !== 1 && record.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.reView(record);
            }
          }
        }, [_vm._v(" 审核 ")]) : _vm._e(), _c('a-popconfirm', {
          attrs: {
            "title": "你确定撤回该公文吗?",
            "ok-text": "确定",
            "cancel-text": "取消"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.handleWithdrawOption(record);
            }
          }
        }, [record.tempId === 4 && record.auditStatus == 1 && record.auditStep == 1 && record.docStatus == 1 || record.docStatus == 4 && record.isEmergent == 1 ? _c('a-button', {
          attrs: {
            "type": "link"
          }
        }, [_vm._v(" 撤回 ")]) : _vm._e()], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };